import { render, staticRenderFns } from "./BlankTable.vue?vue&type=template&id=ba116124&scoped=true&"
import script from "./BlankTable.vue?vue&type=script&lang=js&"
export * from "./BlankTable.vue?vue&type=script&lang=js&"
import style0 from "./BlankTable.vue?vue&type=style&index=0&id=ba116124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba116124",
  null
  
)

export default component.exports